import { setDocTitle } from "../../../functions/HelperFuncs";
import { userHasAllRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next.js";

export default {
  data() {
    return {
      id: this.$options.name,
    };
  },
  beforeMount() {
    //check if mobile
    this.redirect();
  },
  created() {
    setDocTitle("spaces", this);
  },
  methods: {
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to collections
        this.$router.replace(`/${this.$store.state.company}`);
      }
    },
    transferSelected() {
      //got to the transfer
      this.$router.push(`/${this.$store.state.company}/mobile-transfer`);
    },
  },
  computed: {
    selectedTitle() {
      const selectedItems = this.$store.state.transferItems;
      const count =
        selectedItems.selectedFiles.length +
        selectedItems.selectedFolders.length;
      return `${count} ${count > 1 ? "items" : "item"} selected`;
    },

    uploadTitle() {
      return `${i18n.t(
        "common.currently_in"
      )} <span class="label--tiny-black">${i18n.tc("spaces.space", 2)}</span>`;
    },
    canAddSpace() {
      return !userHasAllRights(["create_spaces"], this);
    },
  },
};
